import React from 'react';

import { AppItem } from '../';
import './style.css';


const AppList = ({ apps }) => (
    <div className='list-container'>
      {apps.map(app => (
        <a key={app.name} href={app.href} className="list-item no-style-link">
          <AppItem app={app} />
        </a>
      ))}
    </div>
);

export default AppList;


// WEBPACK FOOTER //
// ./src/components/AppList/index.js